import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Articulo;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un Articulo
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ArticuloFormNoRx extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Unidad = getField(selectores.ClaveUnidadSat);
        const ProductoSAT = getField(selectores.ClaveProductoSat);

        return (
            <div>
                <kea.Title titulo="Articulo" onRegresar={() => history.go("/catalogos/Articulos")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" label="Nombre:" />,
                    <Number field="Clave" label="Clave Interna del producto:" />,
                    <ProductoSAT field="IdProductoSAT" label="Clave articulo:" />,
                    <Number field="PrecioUnitario" label="Precio unitario:" format="currency" />,
                    <Number field="TasaIva" label="Tasa IVA:" format="percentage" />,
                    <Number field="TasaIeps" label="Tasa IEPS:" format="percentage" />,
                    <Number field="TasaRetencionIva" label="Tasa Retención IVA:" format="percentage" />,
                    <Unidad field="IdUnidadSAT" label="Unidad SAT:" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const ArticuloForm = componentToRx(ArticuloFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/articulos/edit/form.tsx